import React, { useEffect, useState } from "react";
import {
  Box,
  FormControl,
  FormLabel,
  Input,
  Checkbox,
  Button,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Text,
  Select,
  Flex,
  useToast,
  HStack,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  useDisclosure,
  Heading,
  Switch,
  VStack,
  ModalCloseButton,
  IconButton,
  Stack,
} from "@chakra-ui/react";
import { FaUser, FaLink, FaUsers } from "react-icons/fa";
import UserModal from "./UserModel";
import QuickLinkGroupsModel from "./QuickLinkGroupsModel";
import QuickLinksModal from "./QuickLinkGroupsModel";
import { useAppContext } from "../../../context/AppContext";
import {
  fetchUsersGroups,
  addUserGroup,
  updateUserGroup,
  deleteUserGroup,
} from "../../../services/AdminServices/UserGroups";
import { UserGroupModel } from "../../../models/UserGroupModel";

const UserGroups: React.FC = () => {
  const [groupName, setGroupName] = useState("");
  const [isActive, setIsActive] = useState(true);
  const [groups, setGroups] = useState<UserGroupModel[]>([]); // Store groups
  const [isEditing, setIsEditing] = useState<number | null>(null); // For edit mode

  // api integration
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const { accessToken, userData } = useAppContext();

  // tenant id
  const tenantID= userData?.tenantID ||0;

  // delete index UPDATEING
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [deleteIndex, setDeleteIndex] = useState<number | null>(null); // To keep track of which item to delete

  const [searchTerm, setSearchTerm] = useState(""); // For search bar
  const toast = useToast(); // To show toasts
  const { isOpen, onOpen, onClose } = useDisclosure();

  // for page controlling
  const [currentPage, setCurrentPage] = useState(1); // Track the current page
  const [itemsPerPage, setItemsPerPage] = useState(10); // Items per page
  const [description, setDescription] = useState("");

  // userModel Logic -checkMark
  const [isUserModalOpen, setUserModalOpen] = useState(false);
  const openUserModel = (groupId: number) => {
    
    setSelectedGroupId(groupId);
    setUserModalOpen(true);
  };
  const closeUserModal = () => setUserModalOpen(false);
  const [groupUsers, setGroupUsers] = useState<{
    [key: string]: any[];
  }>({});
  const [selectedGroupId, setSelectedGroupId] = useState<number>(0);

  const handleUserSave = (
    groupId: number | null,
    updatedUsers: { id: string; name: string }[]
  ) => {
    if (groupId) {
      
      setGroupUsers((prev) => ({
        ...prev,
        [groupId]: updatedUsers,
      }));
      toast({
        position: "top",
        title: "User Quick Links Updated",
        description: `Users for group ID ${groupId} have been updated.`,
        status: "success",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  // quickLinksgroupsModel Logic -checkMark
  const [isQuickLinksModalOpen, setQuickLinksModalOpen] = useState(false);
  const openQuickLinksModal = (groupId: number) => {
    
    setSelectedUserGroupId(groupId);
    setQuickLinksModalOpen(true);
  };
  const closeQuickLinksModal = () => setQuickLinksModalOpen(false);

  const [quickLinksGroups, setQuickLinksGroups] = useState<{
    [key: string]: any[];
  }>({});

  const [selectedUserGroupId, setSelectedUserGroupId] = useState<number>(0);

  const handleQuickLinksSave = (
    userGroupId: number | null,
    updatedQuickLinks: { id: string; name: string }[]
  ) => {
    if (userGroupId) {
      setQuickLinksGroups((prev) => ({
        ...prev,
        [userGroupId]: updatedQuickLinks,
      }));
      toast({
        position: "top",
        title: "Quick Links Groups Updated",
        description: `Quick Links for User Group ID ${userGroupId} have been updated.`,
        status: "success",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  // CRUD part
  const handleSave = async () => {
    if (!groupName.trim()) {
      toast({
        position: "top",
        title: "Group Name is required",
        description: "Please provide a group name.",
        status: "warning",
        duration: 3000,
        isClosable: true,
      });
      return;
    }
    if (!accessToken) {
      toast({
        position: "top",
        title: "Authentication Error",
        description: "Access token is missing. Please log in again.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    setLoading(true);
    setError(null);

    try {
      if (isEditing !== null) {
        // update userGroup logic
        const UserGroupID = groups[isEditing].userGroupID;
        const updatedGroup = {
          UserGroupID,
          groupName,
          description,
          isActive,
          updateBy : userData?.userID
        };

        const response = await updateUserGroup(updatedGroup, accessToken, tenantID);

        if (typeof response === "object") {
          setGroups((prevGroups) =>
            prevGroups.map((group, index) =>
              index === isEditing ? { ...group, ...response } : group
            )
          );
        } else {
          console.warn("Server response is not valid JSON:", response);
          setGroups((prevGroups) =>
            prevGroups.map((group, index) =>
              index === isEditing ? { ...group, ...updatedGroup } : group
            )
          );
        }
        getUsersGroups();
        toast({
          position: "top",
          title: "Group Updated",
          description: `${groupName} has been updated successfully.`,
          status: "success",
          duration: 3000,
          isClosable: true,
        });
      } else {
        // add new user group logic
        const newGroup = { groupName, description, isActive , createBy: userData?.userID};

        const response = await addUserGroup(newGroup, accessToken, tenantID);

        if (typeof response === "object") {
          setGroups((prev) => [...prev, response]);
        } else {
          
          console.warn("Server response is not valid JSON:", response);
          // setGroups((prev) => [...prev, newGroup]);
        }
        getUsersGroups();
        toast({
          position: "top",
          title: "Group Added",
          description: `${groupName} has been added successfully.`,
          status: "success",
          duration: 3000,
          isClosable: true,
        });
      }
    } catch (error: any) {
      console.error("Save Error:", error);
      toast({
        position: "top",
        title: isEditing !== null ? "Update Failed" : "Add Failed",
        description: "An unexpected error occurred.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });

      setError(
        isEditing !== null
          ? "Failed to update User Group."
          : "Failed to  save User Group."
      );
    } finally {
      setLoading(false);
      handleReset();
      onClose();
    }
  };

  // Edit The Data
  const handleEdit = (userGroupID: number) => {
    const groupToEdit = groups.find(group => group.userGroupID === userGroupID);

    
  if (!groupToEdit) {
    console.error("Group not found for ID:", userGroupID);
    return;
  }

    const originalIndex = groups.findIndex(
      (group) => group.groupName === groupToEdit.groupName
    ); // Find original index in groups array

    // Set the group details into the form
    setGroupName(groupToEdit.groupName);
    setDescription(groupToEdit.description);
    setIsActive(groupToEdit.isActive);
    setIsEditing(originalIndex); // Set the global index for editing

    onOpen(); // Open the modal for editing
  };

  // DELETE Handler
  const handleDelete = async () => {
  

  if (deleteIndex === null) return;

  // Ensure required values exist
  if (!accessToken || !userData || typeof userData.userID !== 'number') {
    toast({
      position: "top",
      title: "Error",
      description: "Missing user data or access token. Cannot proceed with deletion.",
      status: "error",
      duration: 3000,
      isClosable: true,
    });
    return;
  }

  setLoading(true);
  setError(null);

  try {
    const id = groups[deleteIndex].userGroupID;

    // Safe call with guaranteed userData.userID
    await deleteUserGroup(id, accessToken, tenantID, userData.userID);

    const updatedGroups = groups.filter((_, i) => i !== deleteIndex);
    setGroups(updatedGroups);

    toast({
      position: "top",
      title: "Group Deleted",
      description: "The group has been deleted successfully.",
      status: "success",
      duration: 3000,
      isClosable: true,
    });
  } catch (error) {
    console.error("Delete Error:", error);
    setError("Failed to delete group.");
    toast({
      position: "top",
      title: "Delete Failed",
      description: "Unable to delete the group.",
      status: "error",
      duration: 3000,
      isClosable: true,
    });
  } finally {
    setLoading(false);
    closeDeleteModal();
  }
};


  // Rest Form After ADD-UPDATE
  const handleReset = () => {
    setGroupName("");
    setIsActive(true);
    setDescription("");
    setIsEditing(null);
  };

  // For The Model Close
  const handleClose = () => {
    handleReset(); // Reset the form fields
    setIsEditing(null); // Reset the editing mode
    onClose(); // Close the modal
  };

  // When SearchClsoe Back to First Page
  useEffect(() => {
    // Reset to first page when search term changes
    setCurrentPage(1);
  }, [searchTerm]);

  const getUsersGroups = async () => {
    try {
      if (accessToken) {
        // Check if accessToken is not null
        const data = await fetchUsersGroups(accessToken, tenantID);
        setGroups(data);
        console.log(data);
      } else {
        setError("Access token is missing.");
      }
    } catch (error) {
      setError("Failed to fetch users.");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    getUsersGroups();
  }, [accessToken]); // Fetch data when accessToken changes


  // OPEN the Delete Confirmation Modal
  const openDeleteModal = (userGroupID: number) => {
    const index = groups.findIndex(group => group.userGroupID === userGroupID);
    if (index !== -1) {
      setDeleteIndex(index); // ✅ Set the actual array index
      setIsDeleteModalOpen(true);
    } else {
      console.error("Group not found for userGroupID:", userGroupID);
    }
  };
  

  // CLOSE the Delete Confirmation Modal
  const closeDeleteModal = () => {
    setIsDeleteModalOpen(false);
    setDeleteIndex(null); // Clear the index when modal is closed
  };

  // pagination logic form here
  const handleItemsPerPageChange = (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    setItemsPerPage(Number(event.target.value));
    setCurrentPage(1); // Reset to the first page when items per page changes
  };

  const handlePageChange = (page: number) => {
    if (page < 1 || page > totalPages) return;
    setCurrentPage(page);
  };

  // Filter the sites based on the search query
  const filteredSites = groups.filter((site) =>
    site.groupName?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Pagination Logic
  const totalSites = filteredSites.length; // Get total number of filtered sites
  const totalPages = Math.ceil(totalSites / itemsPerPage); // Calculate total pages
  const indexOfLastSite = currentPage * itemsPerPage;
  const indexOfFirstSite = indexOfLastSite - itemsPerPage;
  const currentSites = filteredSites.slice(indexOfFirstSite, indexOfLastSite); // Slice the filtered sites

  return (
    <>
      <Flex justify="space-between" align="center" mb={4} p={6}>
        <Heading as="h2"> User Groups</Heading>

        <Button colorScheme="blue" onClick={onOpen}>
          <i
            className="bi bi-person-fill-add"
            style={{ marginRight: "8px" }}
          ></i>
          Add Group
        </Button>
      </Flex>

      <Box
        p={6}
        shadow="md"
        borderWidth="1px"
        borderRadius={"15px"}
        backgroundColor={"#fff"}
      >
        {/* Page Handler */}
        <Flex justify="space-between" align="center" mb={4}>
          <Flex justify="space-between" align="center" mb={4}>
            <Select
              value={itemsPerPage}
              onChange={handleItemsPerPageChange}
              maxWidth="200px"
            >
              <option value={10}>10 items per page</option>
              <option value={20}>20 items per page</option>
              <option value={30}>30 items per page</option>
            </Select>
          </Flex>
          <FormControl mb={4} maxWidth="300px">
            <Input
              type="text"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              placeholder="Search by group name"
            />
          </FormControl>
        </Flex>
        <Table variant="simple" className="Table">
          <Thead>
            <Tr>
              <Th>Group Name</Th>
              <Th>Group Description</Th>
              <Th>Users</Th>
              <Th>Project's Groups</Th>
              <Th>Status</Th>
              <Th>Actions</Th>
            </Tr>
          </Thead>
          <Tbody>
            {currentSites.map((group) => (
              <Tr key={group.userGroupID}>
                <Td>{group.groupName}</Td>
                <Td>{group.description}</Td>
                <Td>
                  <IconButton
                    icon={<FaUser />}
                    aria-label="Edit User"
                    onClick={() => openUserModel(group.userGroupID)} // Pass the group ID
                    size="sm"
                    colorScheme="blue"
                    ml={5}
                  />
                </Td>
                <Td>
                  <IconButton
                    icon={<FaUsers />}
                    aria-label="Add Quick Link Group"
                    onClick={() => openQuickLinksModal(group.userGroupID)}
                    size="sm"
                    colorScheme="red"
                    ml={0}
                  />
                </Td>
                <Td>
                  <span
                    className={`status-box ${
                      group.isActive ? "active" : "inactive"
                    }`}
                  >
                    {group.isActive ? "Active" : "Inactive"}
                  </span>
                </Td>

                <Td>
                <HStack spacing={2} w="full" justifyContent="flex-start">
                  <Button
                    size="sm"
                    colorScheme="blue"
                    onClick={() => handleEdit(group.userGroupID)}
                    mr={2}
                  >
                    <i className="bi bi-pencil-square"></i>
                  </Button>
                  <Button
                    size="sm"
                    colorScheme="red"
                    onClick={() => openDeleteModal(group.userGroupID)} // Pass array index as 'index'
                  >
                    <i className="bi bi-trash3"></i>
                  </Button>
                  </HStack>
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
        {loading && <Text>Loading...</Text>}
        {/*{error && <Text color="red.500">{error}</Text>} */}

        {/* Delete Model */}
        <Modal isOpen={isDeleteModalOpen} onClose={closeDeleteModal}>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Delete Group</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              {deleteIndex !== null && deleteIndex < groups.length ? (
                <p>
                  Are you sure you want to delete the group "
                  <strong>{groups[deleteIndex].groupName}</strong>"?
                </p>
              ) : (
                <p>Error: Invalid group selected.</p>
              )}
            </ModalBody>

            <ModalFooter>
              <Button colorScheme="red" mr={3} onClick={handleDelete}>
                Yes, Delete
              </Button>
              <Button variant="ghost" onClick={closeDeleteModal}>
                Cancel
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>

        {/* Modals */}

        <UserModal
          isOpen={isUserModalOpen}
          onClose={closeUserModal}
          groupId={selectedGroupId}
          user={
            selectedGroupId !== null ? groupUsers[selectedGroupId] || [] : []
          }
          onSave={(updatedUsers) =>
            handleUserSave(selectedGroupId, updatedUsers)
          }
        />

        {/* <UserModal
          isOpen={isUserModalOpen}
          onClose={closeUserModal}
          groupId={selectedGroupId}
          user={
            selectedGroupId !== null ? groupUsers[selectedGroupId] || [] : []
          }
          onSave={(updatedUsers) =>
            handleUserSave(selectedGroupId, updatedUsers)
          }
        /> */}

        {/* <QuickLinkGroupsModel
          isOpen={isQuickLinkModalOpen}
          onClose={closeQuickLinkModal}
          quickLinksGroupId={selectedQuickLinksGroupId}
          quickLinkGroups={
            selectedQuickLinksGroupId !== null
              ? groupQuickLinks[selectedQuickLinksGroupId] || []
              : []
          }
          onSave={(updatedQuickLinkGroups) =>
            handleQuickLinksSave(
              selectedQuickLinksGroupId,
              updatedQuickLinkGroups
            )
          }
        /> */}
        <QuickLinksModal
          isOpen={isQuickLinksModalOpen}
          onClose={closeQuickLinksModal}
          userGroupId={selectedUserGroupId}
          quickLinks={
            selectedUserGroupId !== null
              ? quickLinksGroups[selectedUserGroupId] || []
              : []
          }
          onSave={(updatedQuickLinks) =>
            handleQuickLinksSave(selectedUserGroupId, updatedQuickLinks)
          }
        />

        {/* Page Info */}
        <Flex justify="space-between" mt={4}>
          <Box>
            <span>
              Showing {(currentPage - 1) * itemsPerPage + 1} to{" "}
              {Math.min(currentPage * itemsPerPage, totalSites)} of {totalSites}{" "}
              entries
            </span>
          </Box>

          {/* Pagination */}
          <HStack spacing={4}>
            <Button
              onClick={() => handlePageChange(currentPage - 1)}
              isDisabled={currentPage === 1}
            >
              Previous
            </Button>

            <Select
              value={currentPage}
              onChange={(e) => handlePageChange(Number(e.target.value))}
              maxWidth="70px"
            >
              {Array.from({ length: totalPages }, (_, index) => (
                <option key={index} value={index + 1}>
                  {index + 1}
                </option>
              ))}
            </Select>

            <Button
              onClick={() => handlePageChange(currentPage + 1)}
              isDisabled={currentPage === totalPages}
            >
              Next
            </Button>
          </HStack>
        </Flex>
        {/* Modal for Add/Edit */}
        <Modal isOpen={isOpen} onClose={handleClose}>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>
              {isEditing !== null ? "Edit Group" : "Add Group"}
            </ModalHeader>
            <ModalCloseButton />
            <hr style={{ border: "1px solid #black" }} />
            <ModalBody>
              <VStack spacing={4} align="stretch">
                {/* Group Name */}
                <FormControl isRequired>
                  <FormLabel>Group Name</FormLabel>
                  <Input
                    value={groupName}
                    onChange={(e) => setGroupName(e.target.value)}
                  />
                </FormControl>
                {/* Organization Name */}
                <FormControl isRequired>
                  <FormLabel>Group Description</FormLabel>
                  <Input
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                  />
                </FormControl>

                {/* Active Status */}
                <FormControl>
                  <Stack alignItems="left">
                    <FormLabel mb={0}>Status</FormLabel>
                    <Switch
                      isChecked={isActive}
                      onChange={(e) => setIsActive(e.target.checked)}
                      colorScheme="blue"
                    />
                  </Stack>
                </FormControl>
              </VStack>
            </ModalBody>
            <hr style={{ border: "1px solid #black" }} />
            <ModalFooter>
              <Button colorScheme="blue" mr={3} onClick={handleSave}>
                {isEditing !== null ? "Update" : "Save"}
              </Button>
              <Button variant="ghost" onClick={handleClose}>
                Cancel
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      </Box>
    </>
  );
};

export default UserGroups;
